import { render, staticRenderFns } from "./VehicleForm.vue?vue&type=template&id=6707b9f1&scoped=true"
import script from "./VehicleForm.vue?vue&type=script&lang=js"
export * from "./VehicleForm.vue?vue&type=script&lang=js"
import style0 from "./VehicleForm.vue?vue&type=style&index=0&id=6707b9f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6707b9f1",
  null
  
)

export default component.exports